import { InjectionToken } from '@angular/core';

/** config 通用介面的服務注入權杖 */
export const GENERATOR_ENV_TOKEN = new InjectionToken<GeneratorEnv>('generator environment token') ;

/** config 通用介面 */
export class GeneratorEnv {
  /** data host */
  apiHost: string;
  /** 首頁編輯用 data host */
  editApiHost: string;
  /** 允許 postmessage 通信的網域 */
  allowBackStageDomain: string[];
  /** 後台登入身分驗證後給的權杖存儲鍵 */
  accessTokenKey: string;
  /** 後台登入身分驗證後給的更新連線用權杖存儲鍵 */
  refreshTokenKey: string;
  /** 配置模式 */
  mode: 'domain' | 'path' = 'domain';
  /** 機器人驗證 key */
  recaptchaKey: string;
  /** 通用網站的取 api token */
  commonToken: string;
}
